module.exports = __webpack_public_path__ + "img/smirk.b3ab72c0.gif";